import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase, camelCase } from 'lodash';
import { createHashHistory } from 'history';
import { Nav, NavItem, NavLink, Container, Row, Col, Card, CardBody } from 'reactstrap';
const hashHistory = createHashHistory();
const ContractSpecContainer = ({
  id,
  section,
  children: _children = null
}) => {
  const handleSelect = key => {
    hashHistory.replace(`/admin/contractSpecs/${id}/${key}`);
  };
  const specs = ['General', 'Ambient Conditions', 'Surface Profile', 'Dry Film Thickness', 'Wet Film Thickness', 'Salt Test'];
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardBody, {
    className: "card-heading"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement("h3", {
    className: "t-cs-sidebar-title"
  }, "Sections")))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Nav, {
    className: "t-cs-nav-section",
    pills: true,
    vertical: true
  }, specs.map((item, index) => /*#__PURE__*/React.createElement(NavItem, {
    active: section.length > 0 ? camelCase(item) === section : index === 0,
    key: `nav-${kebabCase(item)}`,
    className: `t-cs-nav-section-${kebabCase(item)}`
  }, /*#__PURE__*/React.createElement(NavLink, {
    onClick: () => handleSelect(camelCase(item))
  }, item))))))), /*#__PURE__*/React.createElement(Col, {
    sm: 9
  }, _children)));
};
ContractSpecContainer.propTypes = {
  id: PropTypes.string.isRequired,
  section: PropTypes.string.isRequired,
  children: PropTypes.node
};
export default ContractSpecContainer;